module.exports = __webpack_public_path__ + "static/media/bar-brewery-winery-1.4d124441.jpg";